<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="8">
            <a-form-item label="机构名称">
              <a-input
                placeholder="请输入机构名称"
                v-model="searchObj.organizationName"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item label="客户经理">
              <a-input
                placeholder="请输入客户经理"
                v-model="searchObj.customerManager"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item label="会员等级">
              <a-input
                placeholder="请输入会员等级"
                v-model="searchObj.memberGroupName"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <span
              style="float: left; overflow: hidden"
              class="table-page-search-submitButtons"
            >
              <a-button type="primary" @click="searchQuery" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="searchReset"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >

              <!--展开按钮结束-->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-button
        style="margin-left: 8px"
        type="primary"
        icon="download"
        @click="handleExportXls('exportXlsUrl','机构管理')"
        >全部导出</a-button
      >
      <!-- 高级查询区域 -->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="2" @click="handleExportXls('exportXlids','机构管理')"><a-icon type="download"/>选择导出</a-menu-item>
          <a-menu-item key="1" @click="batchDel"
            ><a-icon type="delete" />删除</a-menu-item
          >
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作 <a-icon type="down"
        /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{ x: true }"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm
                  title="确定删除吗?"
                  @confirm="() => handleDelete(record.id)"
                >
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
              <a-menu-item>
                <a @click="goMamber(record.id)">机构会员</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>

    <ct-mo-organization-modal
      ref="modalForm"
      :groupList="groupList"
      @ok="modalFormOk"
    ></ct-mo-organization-modal>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less';
import { getAction,postAction,downFile} from '@/api/manage';
import CtMoOrganizationModal from './modules/CtMoOrganizationModal';
import { filterObj } from '@/utils/util';
const columns = [
  /*{
      title: '#',
      dataIndex: '',
      key:'rowIndex',
      width:60,
      align:"center",
      customRender:function (t,r,index) {
        return parseInt(index)+1;
      }
    },*/
  {
    title: '机构名称',
    align: 'center',
    dataIndex: 'organizationName',
  },
  {
    title: '客户经理',
    align: 'center',
    dataIndex: 'customerManager',
  },
  {
    title: '激活人数',
    align: 'center',
    dataIndex: ' memberActionNum',
    customRender: (text,record) => {
      return (text || "0")+"/"+(record.memberNum||0);
    },
  },
  {
    title: '会员等级',
    align: 'center',
    dataIndex: 'memberGroupName',
  },
  {
    title: '会员开通时间',
    align: 'center',
    dataIndex: 'memberCreateTime',
  },
  {
    title: '会员到期时间',
    align: 'center',
    dataIndex: 'memberEffectiveTime',
  },
  {
    title: '操作',
    dataIndex: 'action',
    align: 'center',
    fixed: 'right',
    width: 147,
    scopedSlots: { customRender: 'action' },
  },
];
export default {
  name: 'CtMoOrganizationList',
  components: {
    CtMoOrganizationModal,
  },
  data() {
    return {
      groupList: [],
      description: '机构管理页面',
      //--------列表页重复代码 start-------------
      searchObj: {
        organizationName: "",
        customerManager: "",
        memberGroupName: "",
      },
      /* 查询折叠 */
      toggleSearchStatus: false,
      /* table选中keys*/
      selectedRowKeys: [],
      loading: false,
      dataSource: [],
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      //--------列表页重复代码 end-------------
      // 表头
      columns,
      url: {
        list:
          process.env.VUE_APP_CMS_CUSTOMER +
          '/organization/ctMoOrganization/getPageList',
        delete:
          process.env.VUE_APP_CMS_CUSTOMER +
          '/organization/ctMoOrganization/deleteById',
        deleteBatch:
          process.env.VUE_APP_CMS_CUSTOMER +
          '/organization/ctMoOrganization/deleteByIds',
        exportXlsUrl:
          process.env.VUE_APP_CMS_CUSTOMER +
          '/organization/ctMoOrganization/exportXls',
        exportXlids:
          process.env.VUE_APP_CMS_CUSTOMER +
          '/organization/ctMoOrganization/exportXlids',
        queryGroup: process.env.VUE_APP_CMS_CUSTOMER + '/member/ctMmGroup/list',
      },
    };
  },
  created() {
    this.loadData(1);
    this.getGroupData();
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
    },
  },
  methods: {
    //-----------------列表页重复代码-开始--------------
    batchDel() {
      if (!this.url.deleteBatch) {
        this.$message.error('请设置url.deleteBatch属性!');
        return;
      }
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      } else {
        let ids = '';
        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ',';
        }
        let that = this;
        this.$confirm({
          title: '确认删除',
          content: '是否删除选中数据?',
          onOk:  ()=> {
            that.loading = true;
            postAction(that.url.deleteBatch, { ids: ids })
              .then((res) => {
                if (res.success) {
                  that.$message.success(res.message);
                  that.loadData();
                  that.onClearSelected();
                } else {
                  that.$message.warning(res.message);
                }
                that.loading = false;
              })
          },
        });
      }
    },
    handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus;
    },
    handleExportXls(exportXlsUrlName,fileName) {
      if (!fileName || typeof fileName != 'string') {
        fileName = '导出文件';
      }
      let param = { ...this.searchObj };
      let idParam = ""
      if (this.selectedRowKeys && this.selectedRowKeys.length > 0) {
        param['ids'] = this.selectedRowKeys.join(',');
        idParam = `?ids=${param.ids}`;
      }
      console.log('导出参数', param);
      downFile(this.url[exportXlsUrlName] + idParam, param).then(data => {
        if (!data) {
          this.$message.warning('文件下载失败');
          return;
        }
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(
            new Blob([data], { type: 'application/vnd.ms-excel' }),
            fileName + '.xls'
          );
        } else {
          let url = window.URL.createObjectURL(
            new Blob([data], { type: 'application/vnd.ms-excel' })
          );
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', fileName + '.xls');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); //下载完成移除元素
          window.URL.revokeObjectURL(url); //释放掉blob对象
        }
      });
    },
    //分页
    handleTableChange(pagination, filters, sorter) {
      this.onClearSelected(); //分页切换时清空表格选中
      //分页、排序、筛选变化时触发
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc';
      }
      this.ipagination = pagination;
      this.loadData();
    },
    loadData(arg) {
      let that = this;
      if (arg === 1) {
        that.ipagination.current = 1;
      }
      let params = this.getQueryParams();
      getAction(this.url.list,params).then(res => {
        that.loading = true;
        if (res.success) {
          that.dataSource =
            res.result && res.result.records ? res.result.records : [];
          that.loading = false;
          that.ipagination.total = res.result.total;
        }
      });
    },
    getQueryParams() {
      let param = Object.assign(
        this.searchObj
      );

      param.field = this.getQueryField();
      param.pageNo = this.ipagination.current;
      param.pageSize = this.ipagination.pageSize;
      return filterObj(param);
    },
    getQueryField() {
      let str = 'id,';
      this.columns.forEach(function(value) {
        str += ',' + value.dataIndex;
      });
      return str;
    },
    handleAdd: function(course) {
      console.log(course);
      if (course) {
        if (course.type == 'click') {
          course = undefined;
        }
      }

      this.$refs.modalForm.add(course);
      this.$refs.modalForm.title = '新增';
      this.$refs.modalForm.disableSubmit = false;
    },
    handleEdit: function(record) {
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = '编辑';
      this.$refs.modalForm.disableSubmit = false;
    },
    handleDetail: function(record) {
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = '详情';
      this.$refs.modalForm.disableSubmit = true;
    },
    handleDelete: function(id) {
      if (!this.url.delete) {
        this.$message.error('请设置url.delete属性!');
        return;
      }
      let that = this;
      postAction(that.url.delete, { id: id }).then(res => {
        if (res.success) {
          that.$message.success(res.message);
          that.loadData();
        } else {
          that.$message.warning(res.message);
        }
      });
    },
    modalFormOk() {
      // 新增/修改 成功时，重载列表
      this.loadData();
    },
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
      console.log(this.name);
      if (this.name == 'courseManageModal') {
        let courseList = selectedRowKeys;
        this.form.setFieldsValue({
          courseList
        });
      }
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    },
    searchQuery() {
      this.loadData(1);
    },
    //重置
    searchReset() {
      this.searchObj = {};
      this.loadData(1);
    },
    //-----------------列表页重复代码-结束--------------
    getGroupData() {
      getAction(this.url.queryGroup).then((res) => {
        if (res.success) {
          this.groupList = res.result.records;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    goMamber(id) {
      this.$router.push({ path: '/customer/organizationmamber/CtMoMemberList', query: { id: id} });
    },
  },
};
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>